<p-carousel [value]="clients" [numVisible]="5" [numScroll]="1" [circular]="true" [autoplayInterval]="3000"
  [showIndicators]="false" [showNavigators]="false" [responsiveOptions]="responsiveOptions" styleClass="client-carousel"
  dir="ltr" (onPage)="onPageChange($event)">
  <ng-template pTemplate="item" let-client>
    <div class="client-logo-wrapper text-center">
      <a [href]="client.link" target="_blank" rel="noopener noreferrer">
        <img [src]="client.imageUrl" alt="Client Logo" class="client-logo" />
      </a>
    </div>
  </ng-template>
</p-carousel>

<!-- Mobile dots indicator -->
<div class="mobile-dots" *ngIf="isMobile && totalDots > 1">
  <span *ngFor="let dot of dotsArray; let i = index" class="dot" [class.active]="i === activeDotIndex"></span>
</div>